<template>
  <section id="loginPage" class="is-medium">
    <div class="columns is-gapless is-centered">
      <div class="column hero is-fullheight">
        <div class="hero-body">
          <article class="is-rounded">
            <form novalidate @submit.prevent="resetPassword">
            <div class="card-content">
              <h1 class="title">
                <img src="/static/img/HPB-logo-on-white.svg" alt="logo">
              </h1>
              <flash-message size="is-size-6"></flash-message>
              <br/>
              <h2 class="has-text-weight-bold has-text-centered is-size-4">Reset Your Password</h2>
              <p class="control">
                <vue-password v-model="form.password" :disabled="sending" classes="input is-size-7"
							  :disableStrength="disableStrength" placeholder="Password">
                </vue-password>
              </p>
              <p class="control">
                <vue-password v-model="form.password_confirmation" :disabled="sending" classes="input is-size-7"
							  :disableStrength="disableStrength" placeholder="Password">
                </vue-password>
                <span class="help is-danger" v-if="passwordsDontMatch">Passwords don't match</span>
                <span class="help is-success" v-if="passwordsMatch">Passwords match</span>
              </p>
              <p class="control">
                <button :disabled="!passwordsMatch" type="submit"
                        class="margin-top-30 button is-button-blue is-fullwidth is-size-7 is-uppercase has-text-weight-bold"
						:class="[{ 'is-loading': sending}]">Reset Password</button>
              </p>
            </div>
            </form>
          </article>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  /* eslint-disable indent,no-new,no-undef */
  import ApiResource from '../../api/ApiResource'
  import VuePassword from 'vue-password'
  import FlashMessage from '../../components/FlashMessageStrip'

  export default {
    metaInfo: {
      title: 'Business Portal | Hellopeter - Update Password'
    },
    mounted () {
      this.$gtm.trackEvent({
        event: 'pageLoad',
        virtualPageUrl: this.$router.currentRoute.path,
        virtualPageTitle: 'Update Password'
      })
    },
    components: {
      VuePassword,
      FlashMessage
    },
    props: ['id'],
    data () {
      return {
        has_errors: false,
        disableStrength: true,
        sending: false,
        form: new ApiResource({
          password: '',
          password_confirmation: ''
        })
      }
    },
    watch: {},
    created () {
      this.verifyToken()
    },
    computed: {
      passwordsDontMatch () {
        return (this.form.password.length > 0 && this.form.password_confirmation.length > 0) && this.form.password !== this.form.password_confirmation
      },
      passwordsMatch () {
        return this.form.password.length > 0 && this.form.password === this.form.password_confirmation
      }
    },
    methods: {
      getNotificationMessage () {
        if (this.form.errors.any()) {
          return this.form.errors.getDefaultErrorMessage()
        }
      },
      verifyToken () {
        const resetToken = new ApiResource({})
        resetToken.send(`/update-password/${this.id}`, {}, 'get')
          .catch(() => {
            this.$router.push('/404')
          })
      },
      resetPassword () {
        this.sending = true
        this.form.send(`/update-password/${this.id}`)
          .then(() => {
            this.sending = false
            this.$router.push({
              path: '/login',
              query: {notification: 'Your password has been changed successfully. Sign in to continue'}
            })
            flash('Your password has been changed successfully. Sign in to continue', 'is-success')
          })
          .catch(() => {
            this.sending = false
            flash(this.form.errors.getDefaultErrorMessage(), 'is-danger')
          })
        }
      }
  }
</script>

<style>
  #loginPage article {
	  max-width: 450px;
	  width: 100%;
	  margin-left: auto;
	  margin-right: auto;
	  box-shadow: none;
  }

  #loginPage #loginButton {
	  margin-top: 30px;
  }

  #loginPage input {
	  border-radius: 0 !important;
	  border: 1px solid #dbdbdb !important;
	  box-shadow: none !important;
	  height: 3em;
  }

  #loginPage .control {
	  margin-top: 30px;
  }

  #loginPage button {
	  border: 0;
	  border-radius: 0;
	  height: 3em;
  }

  #loginPage p.control:last-child {
	  margin-top: 50px;
  }

  #loginPage a.VuePassword__Toggle {
	  color: gray !important;
  }

  @media screen and (max-width: 768px) {
	  #loginPage .column:not(:first-child) p {
		  padding-left: 1rem;
		  padding-right: 1rem;
	  }
  }

  h2 {
	  margin-bottom: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/auth/UpdatePassword.vue